var map = {
	"./ar.png": 72481,
	"./de.png": 45401,
	"./en.png": 97233,
	"./es.png": 19028,
	"./fr.png": 77324,
	"./he.png": 89597,
	"./hu.png": 13,
	"./icons8-austria.png": 76240,
	"./icons8-canada.png": 70091,
	"./icons8-china.png": 7820,
	"./icons8-france.png": 65712,
	"./icons8-germany.png": 23222,
	"./icons8-hungary.png": 27891,
	"./icons8-india.png": 17224,
	"./icons8-israel.png": 40957,
	"./icons8-italy.png": 77156,
	"./icons8-japan.png": 38745,
	"./icons8-new_zealand.png": 11953,
	"./icons8-saudi_arabia.png": 52840,
	"./icons8-singapore.png": 27195,
	"./icons8-south_korea.png": 9689,
	"./icons8-usa.png": 63692,
	"./it.png": 92847,
	"./ja.png": 36499,
	"./ko.png": 75090,
	"./ru.png": 98207,
	"./zh.png": 48306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56667;